export default __webpack_public_path__ + "static/ben-2-cfef81b71c76625f8fa1a731ec7081d6.png";